import React from 'react';
import { getReferenceChipClasses, type ReferenceChipKind } from './styles';

/**
 * ReferenceChip component props
 */
interface ReferenceChipProps {
  kind: ReferenceChipKind;
  label: string;
  className?: string;
}

/**
 * A small visual chip component for displaying reference information with different visual styles
 */
export const ReferenceChip: React.FC<ReferenceChipProps> = ({
  kind,
  label,
  className = '',
}) => {
  return (
    <span className={getReferenceChipClasses(kind, className)}>{label}</span>
  );
};
